export const track = (key, selections) => {
  if (typeof window !== 'undefined' && window.LIFE_CYCLE_EVENT_BUS) {
    window.top.LIFE_CYCLE_EVENT_BUS.trigger(`parts-and-services-drawer.${key}`, selections);
  }
};
